export { default } from './es/icons/FolderFilled';